module.exports = __webpack_public_path__ + "img/thumbnail_CapuchinMonkey_j_albino.36c9989c.png";